import React from 'react';
import { SEO } from '../components/SEO';
export function DatenschutzPage() {
  return <>
      <SEO title="Datenschutzerklärung - CRM Kraft | Justus Kraft" description="Datenschutzerklärung von CRM Kraft. Informationen zur Datenerfassung, Verarbeitung und Ihren Rechten gemäß DSGVO." keywords="Datenschutz, DSGVO, Datenschutzerklärung, CRM Kraft, Justus Kraft" ogType="website" data-id="element-350" data-mp="roz49ciudvj6" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-351" data-mp="d1dz7d2epm8m">
        <div className="max-w-4xl mx-auto" data-id="element-352" data-mp="8z97wkzfl1p5">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-353" data-mp="8xg0v4kwofgm">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-354" data-mp="420qwnq0r3ph">
            <section className="mb-8" data-id="element-355" data-mp="3v7ivcbpsavce">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-356" data-mp="3v8k9wq60dzyv">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-357" data-mp="1tel0kacg5sot">
                Allgemeine Hinweise
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-358" data-mp="3i0caem2cuwto">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-359" data-mp="3r2lm3f9d0w8n">
                Datenerfassung auf dieser Website
              </h3>

              <h4 className="text-lg font-semibold mb-2 text-white mt-4" data-id="element-360" data-mp="3w0dk8r0llela">
                Wer ist verantwortlich für die Datenerfassung auf dieser
                Website?
              </h4>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-361" data-mp="sdmyuoqozkmj">
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                „Hinweis zur Verantwortlichen Stelle" in dieser
                Datenschutzerklärung entnehmen.
              </p>

              <h4 className="text-lg font-semibold mb-2 text-white mt-4" data-id="element-362" data-mp="sc8oh63s61yu">
                Wie erfassen wir Ihre Daten?
              </h4>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-363" data-mp="j9zfwls2oio3">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
                mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
                in ein Kontaktformular eingeben.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-364" data-mp="4ll4vnki5nwg">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung
                beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                sind vor allem technische Daten (z. B. Internetbrowser,
                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                dieser Daten erfolgt automatisch, sobald Sie diese Website
                betreten.
              </p>

              <h4 className="text-lg font-semibold mb-2 text-white mt-4" data-id="element-365" data-mp="2g7ncuvzv1y72">
                Wofür nutzen wir Ihre Daten?
              </h4>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-366" data-mp="2l6q5ti2kgdyo">
                Ein Teil der Daten wird erhoben, um eine fehlerfreie
                Bereitstellung der Website zu gewährleisten. Andere Daten können
                zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>

              <h4 className="text-lg font-semibold mb-2 text-white mt-4" data-id="element-367" data-mp="1xg4ckwx80y8q">
                Welche Rechte haben Sie bezüglich Ihrer Daten?
              </h4>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-368" data-mp="14tjj9qx6qc2j">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                Herkunft, Empfänger und Zweck Ihrer gespeicherten
                personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                können Sie diese Einwilligung jederzeit für die Zukunft
                widerrufen. Außerdem haben Sie das Recht, unter bestimmten
                Umständen die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-369" data-mp="7z8st3skami2">
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
                sich jederzeit an uns wenden.
              </p>

              <h4 className="text-lg font-semibold mb-2 text-white mt-4" data-id="element-370" data-mp="29seywsmdimeq">
                Analyse-Tools und Tools von Drittanbietern
              </h4>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-371" data-mp="1vluyml48yqdi">
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                ausgewertet werden. Das geschieht vor allem mit sogenannten
                Analyseprogrammen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-372" data-mp="1luqt0c0gohvc">
                Detaillierte Informationen zu diesen Analyseprogrammen finden
                Sie in der folgenden Datenschutzerklärung.
              </p>
            </section>

            <section className="mb-8" data-id="element-373" data-mp="1gyjn2j82f6de">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-374" data-mp="1gvdwt0np9yg3">
                2. Hosting
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-375" data-mp="17wsixit6b7ln">
                Webflow
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-376" data-mp="2xc04ocdcm5m3">
                Wir hosten unsere Website bei Webflow. Anbieter ist die Webflow,
                Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA
                (nachfolgend Webflow). Wenn Sie unsere Website besuchen, erfasst
                Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-377" data-mp="2qv8ecthbt2x9">
                Webflow ist ein Tool zum Erstellen und zum Hosten von Websites.
                Webflow speichert Cookies oder sonstige
                Wiedererkennungstechnologien, die für die Darstellung der Seite,
                zur Bereitstellung bestimmter Webseitenfunktionen und zur
                Gewährleistung der Sicherheit erforderlich sind (notwendige
                Cookies).
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-378" data-mp="39rzrel69ylsv">
                Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#FF5722] hover:underline" data-id="element-379" data-mp="66arlhb0gwq3">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-380" data-mp="inv4l3j7y9ox">
                Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs.
                1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
                möglichst zuverlässigen Darstellung unserer Website. Sofern eine
                entsprechende Einwilligung abgefragt wurde, erfolgt die
                Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit.
                a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die
                Speicherung von Cookies oder den Zugriff auf Informationen im
                Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des
                TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-381" data-mp="1fbrjm3z0cwy1">
                Die Datenübertragung in die USA wird auf die
                Standardvertragsklauseln der EU-Kommission gestützt. Details
                finden Sie hier:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#FF5722] hover:underline" data-id="element-382" data-mp="2ani969mweux5">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            <section className="mb-8" data-id="element-383" data-mp="1rowbl4qlblxz">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-384" data-mp="1rpyxszcyx07k">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-385" data-mp="z7jwzwwfbsrp">
                Datenschutz
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-386" data-mp="u7yyfnl61mfi">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-387" data-mp="30wr5ok7opymz">
                Wenn Sie diese Website benutzen, werden verschiedene
                personenbezogene Daten erhoben. Personenbezogene Daten sind
                Daten, mit denen Sie persönlich identifiziert werden können. Die
                vorliegende Datenschutzerklärung erläutert, welche Daten wir
                erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu
                welchem Zweck das geschieht.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-388" data-mp="246qiuqqvls8b">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.
                B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
                kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
                Dritte ist nicht möglich.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-389" data-mp="5we57png3bat">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-390" data-mp="aufp2csp3enc">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-391" data-mp="yckl0adf3x8">
                CRM Kraft LLC
                <br data-id="element-392" data-mp="3j3y0cmnqxwp3" />
                Vertreten durch: Justus Kraft
                <br data-id="element-393" data-mp="3o1pqpc8qtar6" />
                7901 4th St. N, Ste. 300
                <br data-id="element-394" data-mp="3o2988ruhdx4o" />
                St. Petersburg, FL 33702
                <br data-id="element-395" data-mp="1hb9q3tcoq8zt" />
                United States of America
                <br data-id="element-396" data-mp="1mame4hfalm3z" />
                Telefon:{' '}
                <a href="tel:+4915735999071" className="text-[#FF5722] hover:underline" data-id="element-397" data-mp="1m9bdgqh58uh3">
                  +49 157 35999071
                </a>
                <br data-id="element-398" data-mp="1rgrikvmtwkng" />
                E-Mail:{' '}
                <a href="mailto:justus@crm-kraft.de" className="text-[#FF5722] hover:underline" data-id="element-399" data-mp="256v0xbil7u7m">
                  justus@crm-kraft.de
                </a>
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-400" data-mp="2f49gl8woseyv">
                Verantwortliche Stelle ist die natürliche oder juristische
                Person, die allein oder gemeinsam mit anderen über die Zwecke
                und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
                Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-401" data-mp="trpsdqvrz1g3">
                Speicherdauer
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-402" data-mp="pqw8d8lge6sh">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
                Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine
                Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe
                für die Speicherung Ihrer personenbezogenen Daten haben (z. B.
                steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                letztgenannten Fall erfolgt die Löschung nach Fortfall dieser
                Gründe.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-403" data-mp="3mhbhx4qgebiu">
                SSL- bzw. TLS-Verschlüsselung
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-404" data-mp="3rfwhr31smt6r">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
                oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                erkennen Sie daran, dass die Adresszeile des Browsers von
                „http://" auf „https://" wechselt und an dem Schloss-Symbol in
                Ihrer Browserzeile.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-405" data-mp="23m1f3ja5207p">
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
                Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
                werden.
              </p>
            </section>

            <section className="mb-8" data-id="element-406" data-mp="1ousiurbqdgll">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-407" data-mp="2ma6ekejriz0p">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-408" data-mp="2hiy5jjmchfo2">
                Cookies
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-409" data-mp="220ezuw99nblu">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-410" data-mp="33rbyrqkkyah0">
                Kontaktformular
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-411" data-mp="38i21sx5ja18j">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                weiter.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-412" data-mp="e3fktrtzsgl1">
                Anfrage per E-Mail, Telefon oder Telefax
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-413" data-mp="96p2exupt8wg">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
                Ihre Anfrage inklusive aller daraus hervorgehenden
                personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section className="mb-8" data-id="element-414" data-mp="r6i4ep863e5o">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-415" data-mp="r9mj4gj9dsal">
                5. Plugins und Tools
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-416" data-mp="107gcpjpn27u2">
                YouTube
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-417" data-mp="155zzfmc23nnh">
                Diese Website bindet Videos der Website YouTube ein. Betreiber
                der Website ist die Google Ireland Limited („Google"), Gordon
                House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-418" data-mp="hgfcytgp289g">
                Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
                der Datenschutzerklärung von YouTube unter:{' '}
                <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#FF5722] hover:underline" data-id="element-419" data-mp="3kxfh5j7h5yrx">
                  https://policies.google.com/privacy?hl=de
                </a>
                .
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-420" data-mp="38fbefu3dkt4i">
                Google Web Fonts
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-421" data-mp="34cy8b4kput77">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}